module.exports = __webpack_public_path__ + "img/screen-3.c28cc1ae.png";